import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import BPImage from '../../ui/v2/image';

const languages = [
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/pt.svg`,
      alt: 'about:culture.languages.pt',
    },
    title: 'about:culture.languages.pt',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/en.svg`,
      alt: 'about:culture.languages.en',
    },
    title: 'about:culture.languages.en',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/da.svg`,
      alt: 'about:culture.languages.dk',
    },
    title: 'about:culture.languages.dk',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/it.svg`,
      alt: 'about:culture.languages.it',
    },
    title: 'about:culture.languages.it',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/es.svg`,
      alt: 'about:culture.languages.es',
    },
    title: 'about:culture.languages.es',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/fr.svg`,
      alt: 'about:culture.languages.fr',
    },
    title: 'about:culture.languages.fr',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/nb.svg`,
      alt: 'about:culture.languages.no',
    },
    title: 'about:culture.languages.no',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/de.svg`,
      alt: 'about:culture.languages.de',
    },
    title: 'about:culture.languages.de',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/nl.svg`,
      alt: 'about:culture.languages.nl',
    },
    title: 'about:culture.languages.nl',
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/pl.svg`,
      alt: 'about:culture.languages.pl',
    },
    title: 'about:culture.languages.pl',
  },
];

const Culture: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <section className={cx('container', 'grid', 'lg:gap-6', 'mx-auto', 'p-4')}>
      <div className="py-3 lg:py-9">
        <h2 className="font-bold text-2xl pb-3">{t('about:culture.title')}</h2>
        <Trans
          i18nKey="about:culture.text"
          components={{ p: <p className="py-3 text-justify" />, b: <b /> }}
        />
        <ul className="flex flex-wrap lg:flex-row w-full lg:justify-between">
          {languages.map((item, index) => (
            <li
              key={item.title}
              className={cx(
                'py-3',
                'flex',
                'lg:flex-row',
                'w-1/2',
                'lg:w-1/3',
                index % 2 !== 0 ? 'flex-row-reverse' : ''
              )}
            >
              <div className={'rounded-xl shadow-md h-6 inline-block'}>
                <BPImage
                  className="shadow-sm"
                  height={24}
                  width={24}
                  layout="fixed"
                  src={item.flag.src}
                  alt={t(item.flag.alt)}
                />
              </div>
              <h3
                className={cx(
                  'font-bold',
                  'text-lg',
                  index % 2 !== 0 ? 'mr-3 lg:ml-3' : 'ml-3'
                )}
              >
                {t(item.title)}
              </h3>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Culture;
